import { useLocation } from "react-router-dom";
import KioskConfirmation from "./KioskConfirmation";

export default function KioskUsageConfirmation() {
  const { state } = useLocation();
  const isUpdatingUsage = state?.toolUsageFlow === "update";
  const heading = isUpdatingUsage
    ? (state?.usageSaved ? "Tool usage saved" : "Tool usage unchanged")
    : "Check-in complete";

  return (
    <KioskConfirmation
      status="success"
      heading={heading}
      subtitle="Please remember to check out when you leave."
      title={`${heading} – Pinpoint`}
    />
  );
}
